import "@/App.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LangProvider } from "@/components/site/LanguageContext";
import { AccessGate } from "@/components/site/AccessGate";
import { Seo } from "@/components/site/Seo";
import SmoothScroll from "@/components/site/SmoothScroll";
import { Header } from "@/components/site/Header";
import { Hero } from "@/components/site/Hero";
import { MozzarellaShow } from "@/components/site/MozzarellaShow";
import { Marquee } from "@/components/site/Marquee";
import { Manifesto } from "@/components/site/Manifesto";
import { Experience } from "@/components/site/Experience";
import { MediterraneanStage } from "@/components/site/MediterraneanStage";
import { Team } from "@/components/site/Team";
import { BusinessModels } from "@/components/site/BusinessModels";
import { GrandEvents } from "@/components/site/GrandEvents";
import { Gallery } from "@/components/site/Gallery";
import { ContactCTA } from "@/components/site/ContactCTA";
import { Footer } from "@/components/site/Footer";
import { useLang } from "@/components/site/LanguageContext";

const opCopy = {
  en: { kicker: "The One-Pager · To take away", h2: <>The whole concept, <em className="italic">on one page.</em></>, dl: "Download the PDF version" },
  it: { kicker: "Il One-Pager · Da portare via", h2: <>Tutto il concept, <em className="italic">in una pagina.</em></>, dl: "Scarica la versione PDF" },
  ru: { kicker: "One-Pager · С собой", h2: <>Весь концепт, <em className="italic">на одной странице.</em></>, dl: "Скачать PDF-версию" },
  es: { kicker: "El One-Pager · Para llevar", h2: <>Todo el concepto, <em className="italic">en una página.</em></>, dl: "Descargar la versión PDF" },
};

const FilataOnePagerOpen = () => {
  const { lang } = useLang();
  const o = opCopy[lang];
  return (
    <section className="bg-[#ece1cd] py-20 md:py-28" data-testid="onepager-open">
      <div className="max-w-[1000px] mx-auto px-6 md:px-10">
        <div className="max-w-2xl mb-10">
          <p className="font-sans text-xs uppercase tracking-[0.35em] text-terracotta mb-4">{o.kicker}</p>
          <h2 className="font-serif text-3xl md:text-5xl text-ink leading-[1.05]">{o.h2}</h2>
        </div>
        <div className="rounded-sm overflow-hidden border border-ink/15 shadow-[0_40px_80px_-30px_rgba(43,14,16,0.4)]">
          <img src="/filata-onepager.png" alt="Filata one-pager" data-testid="onepager-image" className="w-full h-auto block" />
        </div>
        <p className="font-sans text-sm text-ink-soft mt-6 text-center">
          <a href="/filata-onepager.pdf" download="Filata-Live-Mozzarella-Experience.pdf" data-testid="onepager-download-link" className="underline underline-offset-4 decoration-terracotta/50 hover:decoration-terracotta transition-colors">
            {o.dl}
          </a>
        </p>
      </div>
    </section>
  );
};
import PLModel from "@/pages/PLModel";
import Pizzeria from "@/pages/Pizzeria";
import Hub from "@/pages/Hub";
import PatriziasLanding from "@/pages/PatriziasLanding";
import V2Landing from "@/pages/V2Landing";
import Visite from "@/pages/Visite";
import Guida from "@/pages/Guida";
import Dossier from "@/pages/Dossier";

function Landing() {
  return (
    <div className="App" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <SmoothScroll>
        <Header />
        <main>
          <Hero countdown={false} />
          <MozzarellaShow countdown={false} />
          <Marquee />
          <Manifesto />
          <Experience ways="2" />
          <MediterraneanStage luxury />
          <Team luxury />
          <BusinessModels />
          <GrandEvents variant="ilusha" />
          <Gallery />
          <FilataOnePagerOpen />
          <ContactCTA />
        </main>
        <Footer />
      </SmoothScroll>
    </div>
  );
}

function EventsLanding() {
  return (
    <div className="App" data-testid="app-root">
      <div className="noise-overlay" aria-hidden="true" />
      <SmoothScroll>
        <Header />
        <main>
          <Hero countdown={false} />
          <MozzarellaShow countdown={false} />
          <Marquee />
          <Manifesto />
          <Experience ways="2" />
          <MediterraneanStage luxury />
          <Team luxury />
          <BusinessModels variant="luxury" />
          <GrandEvents variant="ilusha" />
          <Gallery />
          <ContactCTA />
        </main>
        <Footer />
      </SmoothScroll>
    </div>
  );
}

function App() {
  return (
    <LangProvider>
      <AccessGate>
        <BrowserRouter>
        <Seo />
        <Routes>
          <Route path="/" element={<Landing />} />
          <Route path="/live-mozzarella-experience" element={<Landing />} />
          <Route path="/events" element={<EventsLanding />} />
          <Route path="/luxury-wedding-events-show-cooking" element={<EventsLanding />} />
          <Route path="/pnl" element={<PLModel />} />
          <Route path="/pizzeria" element={<Pizzeria />} />
          <Route path="/hub" element={<Hub />} />
          <Route path="/patrizias" element={<PatriziasLanding />} />
          <Route path="/v2" element={<V2Landing />} />
          <Route path="/visite" element={<Visite />} />
          <Route path="/guida" element={<Guida />} />
          <Route path="/dossier" element={<Dossier />} />
        </Routes>
        <Toaster position="bottom-right" />
        </BrowserRouter>
      </AccessGate>
    </LangProvider>
  );
}

export default App;
